<div *ngIf="videoDetails" class="row justify-content-center">
    <div class="col-10 d-flex pt-3 video-playback flex-column align-items-center">
        <h5 class="font-weight-bold">{{ videoDetails.title }}</h5>
        <p class="font-weight-light">
            {{ videoDetails.p }}
        </p>
    </div>
    <div class="col-10 d-flex pt-3  flex-column align-items-center video-content">
        <h3>
            {{ videoDetails.videoTitle }}
        </h3>
        <p>
            {{ videoDetails.videoContent }}
        </p>
        <div class="video-player position-relative" (click)="clickOnImage()">
            <img [src]="videoDetails.videoImageLink" alt="">
        </div>
        <div class="iframe-div position-relative" [ngStyle]="{'display': openIframe ? 'block' : 'none'}">
            <div class="iframe-video">
                  <img src="../../../../assets/close-icon.svg" (click)="closeVideo()"/>
                <iframe id="myVideoIframe" [src]="videoDetails.videoLink | safepipe"
                    frameborder="0" allow="autoplay" allowfullscreen></iframe>
                    <div class="video-details position-absolute d-flex flex-column">
                        <h3> {{ videoDetails.videoTitle }} </h3>
                        <h6>Presta atención a lo que te rodea mientras miras el video</h6>
                    </div>
            </div>
        </div>
        <p>
            {{ videoDetails.videoFooter }}
        </p>
    </div>
</div>